import React, { useState, useContext } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import GenericDialogBox from '../GenericDialogBox';
import InfoBox from '../InfoBox';
import DataService from "../../services/data.service";
import { useTranslation } from "react-i18next";
import ConfigContext from '../../contexts/ConfigContext';
import { alpha } from '@material-ui/core/styles';

import reportData from './reportData';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        maxWidth: 500,
        margin: 'auto',
        overflow: 'hidden',
        backgroundColor: 'white'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {

        margin: theme.spacing(3, 2, 2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));


const productEndpoint = `product`
const configEndpoint = `configuration`
const DATE_FORMAT = 'yyyy-MM-dd';

const ReportForm = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const { reportGroup } = props;
    const { configData } = useContext(ConfigContext)

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [toData, setToData] = useState("9999999999");
    const [fromData, setFromData] = useState("0");
    const [selectedReport, setSelectedReport] = useState("-");
    const [selectedReportValue, setSelectedReportValue] = useState("");

    // INFO NOTIFICATION VARS
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoBody, setInfoBody] = useState('');
    //***********************

    //Dialog Vars
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogueTitle, setDialogueTitle] = useState('');
    const [dialogueBody, setDialogueBody] = useState('');
    //**********

    // DIALOG FUNCTIONS
    const handleDialogOk = () => {
        setDialogOpen(false)
    };

    const handleDialogClose = () => {
        setDialogOpen(false)
    };

    const openDialogBox = (title, body) => {
        setDialogueTitle(title)
        setDialogueBody(body)
        setDialogOpen(true)
    };
    //*******************

    // Notification INFO functions
    const openNoticeBox = (title, body) => {
        setInfoTitle(title)
        setInfoBody(body)
        setInfoOpen(true)
    };

    const handleInfoClose = () => {
        setInfoOpen(false)
    };
    // *****************

    const getData = (endpoint, payload) => {
        var varPromise = DataService.getReport(endpoint, payload)
            .catch(e => {
                console.log(e)
                if (e.response.status !== 404) {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
                } else {
                    // setData({})
                    console.log("Unexpected error: ", e)
                }
            });
        return varPromise
    }

    const getData2 = (endpoint, payload) => {
        var varPromise = DataService.getReport2(endpoint, payload)
            .catch(e => {
                console.log(e)
                if (e.response.status !== 404) {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
                } else {
                    // setData({})
                    console.log("Unexpected error: ", e)
                }
            });
        return varPromise
    }
    const submitForm = (event) => {
        event.preventDefault();

        // console.log(selectedReport.endpoint)
        // const test = getData(selectedReport.endpoint, values);
        // + 'T23:59:59.999Z'
        var newFromDate, newToDate = ""
        newFromDate = format(fromDate, DATE_FORMAT)
        newToDate = format(toDate, DATE_FORMAT)

        var values = {
            'date_from': newFromDate,
            'date_to': newToDate,
            'data_from': fromData,
            'data_to': toData,
        }
        let dataFunc = typeof selectedReport.source === 'undefined' ? getData : getData2
        var newPromise = dataFunc(selectedReport.endpoint, values).then(response => {
            // + 'T23:59:59.999Z'
            values.date_from = values.date_from + 'T23:59:59.999Z'
            values.date_to = values.date_to + 'T23:59:59.999Z'
            // console.log(values.date_from, values.date_to)
            if (typeof selectedReport.source === 'undefined') {
                selectedReport.component(response.data, configData, values)
            } else {
                // Open PDF Here
                var file = new Blob([response.data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }
        })

    }

    const handleReset = (event) => {

    }

    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            <CssBaseline />
            <GenericDialogBox
                opn={dialogOpen}
                handleDialogOk={handleDialogOk}
                handleDialogClose={handleDialogClose}
                title={dialogueTitle}
                body={dialogueBody} />
            <InfoBox
                opn={infoOpen}
                handleDialogClose={handleInfoClose}
                title={infoTitle}
                body={infoBody} />

            <form className={classes.form} onSubmit={submitForm} onReset={handleReset}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Autocomplete
                            id="report_type"
                            // value={value}
                            options={reportData[reportGroup]}
                            getOptionLabel={(option) => option.title ? option.title : "-"}
                            onChange={(event, newValue) => {
                                event.preventDefault()
                                setSelectedReport(newValue);
                            }}
                            inputValue={selectedReportValue}
                            onInputChange={(event, newInputValue) => {
                                setSelectedReportValue(newInputValue);
                            }}

                            value={selectedReport ? selectedReport : ""}
                            renderInput={(params) => <TextField {...params} label={t("report_form_detail_lbl_selected_report")} />}
                            getOptionSelected={(option, value) => option.value === value.value}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6" component="h6">
                            {t("report_form_lbl_date_from")}
                        </Typography>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                clearable="true"
                                value={fromDate}
                                placeholder="2021-07-07"
                                onChange={date => setFromDate(date)}
                                // minDate={new Date()}
                                format={DATE_FORMAT}
                                autoOk
                                name="from_date"
                                id="from_date"
                                variant="inline"
                                inputVariant="outlined"
                                style={{ marginTop: '5px' }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6" component="h6">
                            {t("report_form_lbl_date_to")}
                        </Typography>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                clearable="true"
                                value={toDate}
                                placeholder="2021-07-07"
                                onChange={date => setToDate(date)}
                                // minDate={new Date()}
                                format={DATE_FORMAT}
                                autoOk
                                name="to_date"
                                id="to_date"
                                variant="inline"
                                inputVariant="outlined"
                                style={{ marginTop: '5px' }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6" component="h6">
                            {/* {t("report_form_lbl_from_data")} */}
                        </Typography>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="from_data"
                            label={t("report_form_lbl_from_data")}
                            name="from_data"
                            onChange={event => setFromData(event.target.value)}
                            value={fromData}
                            style={{ marginTop: '-2px' }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6" component="h6">
                            {/* {t("report_form_lbl_to_data")} */}
                        </Typography>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="to_data"
                            label={t("report_form_lbl_to_data")}
                            name="to_data"
                            onChange={event => setToData(event.target.value)}
                            value={toData}
                            style={{ marginTop: '-2px' }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        // onClick = {(event) => setSelectedReportValue(data, configData)}
                        >
                            {t("send_form_button")}

                        </Button>
                    </Grid>
                </Grid>
            </form>
            <Box mt={8}>

            </Box>

        </Paper>
    )
})

export default ReportForm;
    // ReactDOM.render(<WithMaterialUI />, document.getElementById('root'));
